import { Modal } from "antd";
import { FC } from "react";
import { postWorkStopThunk } from "tm-shared/api";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText } from "@/components/Typography/Styled";
import { useAppDispatch } from "@/hooks/redux";
import useAsyncAction from "@/hooks/useAsyncAction";
import { clearMarkets } from "@/store/slices/work/work.slice";

import { StyledButton } from "./Styled";

interface ForceStopWorkModalProps {
    onClose: () => void;
}

export const ForceStopWorkModal: FC<ForceStopWorkModalProps> = ({
    onClose,
}) => {
    const dispatch = useAppDispatch();

    const [handleForceEndWork, isProcessingEndWork] = useAsyncAction(
        async () => {
            await dispatch(postWorkStopThunk({ force: true }));
            dispatch(clearMarkets());
            onClose();
        },
    );

    return (
        <Modal
            title=""
            open
            onOk={onClose}
            onCancel={onClose}
            centered
            closable={false}
            footer={[]}
        >
            <PrimaryText
                fontSize={20}
                fontWeight="500"
                lineHeight="20px"
                textAlign="center"
                padding="0 0 16px 0"
            >
                Ви маєте невиконані завдання
            </PrimaryText>
            <FlexContainer gap="10px">
                <StyledButton type="text" onClick={onClose}>
                    Продовжити роботу
                </StyledButton>
                <StyledButton
                    onClick={handleForceEndWork}
                    loading={isProcessingEndWork}
                    type="primary"
                    danger
                >
                    Все одно вийти
                </StyledButton>
            </FlexContainer>
        </Modal>
    );
};
